import {Component, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map, Observable, startWith, Subject} from 'rxjs';
import {Company} from '../../../model/proposal/company';

@Component({
    selector: 'app-company-form-base',
    template: '',
    standalone: false
})
export abstract class CompanyFormBase implements OnDestroy {
  abstract formGroup: FormGroup;
  protected destroy$ = new Subject<void>();


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validStatus(): Observable<boolean> {
    return this.formGroup.valueChanges.pipe(
      map(() => this.formGroup.valid), startWith(false));
  }

  abstract updateCompany(company: Company): void;

}
